export default {
  food_getVariationName(lang, variation) {
    return variation[lang] || variation.it;
  },
  // food_getDeliverySlots(vue, license, timezone, isCustomer) {
  food_getDeliverySlots({ vue, license, timezone, isCustomer }) {
    // From now until last shift of tomorrow
    const slots = [];
    // Get starting moment
    let now, cursor;
    if(isCustomer) {
      now = vue.$moment.tz(timezone).add(license.deliveryMinutesThreshold, 'minutes');
      // Create cursor and round to 15 minutes
      cursor = now.clone().add(15 - (now.minute() % 15), 'minutes').seconds(0);
    } else  {
      now = vue.$moment.tz(timezone);
      // Create cursor and round to 15 minutes
      cursor = now.clone().subtract(now.minute() % 15, 'minutes').seconds(0);
    }
    let dayIndex = now.isoWeekday() - 1;
    let crossDays = false;
    //today
    license.openingHours[dayIndex].forEach(period => {
      const start = vue.$moment.tz(cursor.format('YYYY-MM-DD') + ' ' + period.from, 'YYYY-MM-DD HH:mm', timezone);
      const end = vue.$moment.tz(cursor.format('YYYY-MM-DD') + ' ' + period.to, 'YYYY-MM-DD HH:mm', timezone);
      end.add(1, 'minutes');
      // Check if overflow
      if(end.isBefore(start, 'hour minute')) {
        crossDays = true;
        end.add(1, 'days');
      }
      if(cursor.isAfter(end, 'hour minute')) {
        return;
      } else {
        if(cursor.isBefore(start, 'hour minute')) {
          cursor.set({'hours': start.hours(), 'minutes': start.minutes()});
        }
      }
      while(cursor.isSameOrBefore(end, 'hour minute')) {
        slots.push({
          slot: cursor.clone(),
          free: true
        });
        cursor.add(15, 'minutes');
      }
    });
    // next open day
    if(!crossDays) {
      cursor.add(1, 'days').startOf('day');
    }
    dayIndex = (dayIndex + 1) % 7;
    let iterations = 1;
    while(license.openingHours[dayIndex].length === 0 && iterations < 8) {
      cursor.add(1, 'days');
      dayIndex = (dayIndex + 1) % 7;
      iterations++;
    }
    license.openingHours[dayIndex].forEach((period,i,array) => {
      const start = vue.$moment.tz(cursor.format('YYYY-MM-DD') + ' ' + period.from, 'YYYY-MM-DD HH:mm', timezone);
      const end = vue.$moment.tz(cursor.format('YYYY-MM-DD') + ' ' + period.to, 'YYYY-MM-DD HH:mm', timezone);
      end.add(1, 'minutes');
      if(end.isBefore(start, 'hour minute')) {
        end.add(1, 'days');
      }
      cursor.set({'hours': start.hours(), 'minutes': start.minutes()});
      while(cursor.isSameOrBefore(end, 'hour minute')) {
        slots.push({
          slot: cursor.clone(),
          free: true
        });
        cursor.add(15, 'minutes');
      }
    });
    return slots;
  },
  /* Gestione offline in fase di salvataggio dell'ordine */
  async save({ vue, license, timezone, order, elements, pin }) {
    const lang = vue.$store.state.lang,
      user = vue.$store.state.auth.user;
    const dbPromises = [],
      toPrint = {},
      logs = [];
    // I totali dell'ordine vengono calcolati in fase di salvataggio e denormalizzati
    let listTotal = 0, 
      toPayTotal = 0;
    // Array per salvataggio elementi (mantenimento dell'ordine)
    const elementsToSave = {
      new: [],
      edit: [],
      delete: []
    };
    // Gestione PIN per autenticazione in cassa rapida
    if (pin) {
      const employment = vue.$store.getters["foodEmployments/getByPin"](pin);
      if (employment) {
        user = vue.$store.getters["users/get"](employment.administrator);
      } else {
        return Promise.resolve({ error: "No employment found" });
      }
    }

    let mode = "";
    let oldElements = [];
    // In questo caso la modalità dipende se questo ordine è già presente in vuex (è stato salvato)
    if (!vue.$store.getters['foodOrders/get'](order.id)) {
      mode = "new";
      order.orderDate = vue.$moment().unix();
    } else {
      mode = 'edit';
      oldElements = vue.$store.getters["foodOrderElements/getByOrder"](order.id);
    }
    order.lastModified = vue.$moment().unix();
    if (!order.printedSequence) {
      order.printedSequence = 1;
      order.printedSequenceTime = vue.$moment().unix();
    }
    // Incremento dei totali in base ai campi dell'ordine
    if(order.deliveryPrice > 0) {
      listTotal += order.deliveryPrice;
      if(!order.deliveryPayment) {
        toPayTotal += order.deliveryPrice;
      }
    }
    order.covers[0].forEach(c => {
      listTotal += order.covers[1];
      if(!c) {
        toPayTotal += order.covers[1];
      }
    })

    // Contatori per la modifica delle quantità dei prodotti in inventario
    const productQuantities = {};
    const logData = {
      order: {},
      elements: []
    };
    // Analisi degli elementi dell'ordine
    elements.forEach(e => {
      const oldElement = vue.$store.getters['foodOrderElements/get'](e.id);
      let listPrice, totalPrice, previousDiscount, elementDiscount;
      if (!productQuantities[e.product]) {
        productQuantities[e.product] = 0;
      } 

      if(oldElement) {
        let previousListPrice, previousTotalPrice;
        if (oldElement.weight) {
          previousListPrice = oldElement.weight * oldElement.productUnitPrice;
        } else {
          previousListPrice = oldElement.productUnitPrice;
        }
        previousTotalPrice = oldElement.price;
        previousListPrice += oldElement.variations.reduce((acc, v) => acc + v.listPrice, 0);
        previousTotalPrice += oldElement.variations.reduce((acc, v) => acc + v.price, 0);
        previousDiscount = previousListPrice - previousTotalPrice;
      } else {
        previousDiscount = null;
      }

      if (e.weight) {
        productQuantities[e.product] += e.weight;
        listPrice = e.weight * e.productUnitPrice;
      } else {
        productQuantities[e.product] += 1;
        listPrice = e.productUnitPrice;
      }
      totalPrice = e.price;
      listPrice += e.variations.reduce((acc, v) => acc + v.listPrice, 0);
      totalPrice += e.variations.reduce((acc, v) => acc + v.price, 0);
      // Calcolo eventuale sconto su prodotto
      elementDiscount = listPrice - totalPrice;
      // Se lo sconto è cambiato da quanto precedentemente impostato creo il log
      if((previousDiscount === null && elementDiscount > 0)
          || (previousDiscount !== null && previousDiscount !== elementDiscount)) {
        const localId = vue.$anm22.genLocalId();
        logs.push({
          id: localId,
          dbKey: localId,
          license: license.id,
          user: user.idWorldUser,
          order: order.id,
          ts: vue.$moment().unix(),
          type: 6,
          details: {
            name: e.productName,
            listPrice: listPrice,
            price: totalPrice,
            discount: elementDiscount
          }
        });
      }
      // Aggiungo l'elemento ai log di modifica ordine
      logData.elements.push({
        name: e.productName,
        unitPrice: e.productUnitPrice,
        uom: e.productUom,
        price: e.price,
        weight: e.weight,
        variations: e.variations.map(v => v.sign + ' ' + vue.$anm22.food_getVariationName(lang, v) + ":" + v.price).join(",")
      });
      // Totali
      listTotal += e.price;
      listTotal += e.variations.reduce((acc, v) => acc + v.price, 0);
      if(!e.payment) {
        toPayTotal += e.price;
        toPayTotal += e.variations.reduce((acc, v) => acc + v.price, 0);
      }
      // Stampa elementi nuovi
      if (e.toInsert) {
        const p = vue.$store.getters["foodProducts/get"](e.product);
        const c = vue.$store.getters["foodCategories/get"](p.category);
        if (c.idPrinter) {
          if (p.idPrinter) {
            if (!toPrint[p.idPrinter]) {
              toPrint[p.idPrinter] = {
                new: [],
                delete: []
              };
            }
            toPrint[p.idPrinter].new.push(e);
          } else {
            if (!toPrint[c.idPrinter]) {
              toPrint[c.idPrinter] = {
                new: [],
                delete: []
              };
            }
            toPrint[c.idPrinter].new.push(e);
          }
        }
      }
      const array = e.toInsert ? elementsToSave.new : elementsToSave.edit;
      array.push(e);
      delete(e.toInsert);
    });
    let toDelete = [];
    //Elements to delete
    if (mode === "edit") {
      oldElements.forEach(e => {
        const found = elements.find(ne => ne.id == e.id);
        if(!found) {
          toDelete.push({
            element: e,
            type: 'deleted'
          });
        } else if(JSON.stringify(e.variations) !== JSON.stringify(found.variations)){
          toDelete.push({
            element: e,
            type: 'edited'
          });
        }
      })
      toDelete.forEach(d => {
        const e = d.element;
        if (
          !license.printSequences || order.printedSequence >= e.sequence
        ) {
          const p = vue.$store.getters["foodProducts/get"](e.product);
          const c = vue.$store.getters["foodCategories/get"](p.category);
          if (c.idPrinter) {
            if (p.idPrinter) {
              if (!toPrint[p.idPrinter]) {
                toPrint[p.idPrinter] = {
                  new: [],
                  delete: []
                };
              }
              toPrint[p.idPrinter].delete.push(e);
              if(d.type === 'edited') {
                toPrint[p.idPrinter].new.push(elements.find(ne => ne.id === e.id));
              }
            } else {
              if (!toPrint[c.idPrinter]) {
                toPrint[c.idPrinter] = {
                  new: [],
                  delete: []
                };
              }
              toPrint[c.idPrinter].delete.push(e);
              if(d.type === 'edited') {
                toPrint[c.idPrinter].new.push(elements.find(ne => ne.id === e.id));
              }
            }
          }
        }
        // PUSH SYNC ORDER_ELEMENTS DELETE
        if(d.type === 'deleted') {
          elementsToSave.delete.push(e);
          if (!productQuantities[e.product]) {
            productQuantities[e.product] = 0;
          }
        }
      });
    }

    // INVENTORY MANAGEMENT
    Object.keys(productQuantities).forEach(pid => {
      const product = vue.$store.getters["foodProducts/get"](pid);
      if (product.stockType !== 1) {
        let variation = productQuantities[pid];
        if(mode === 'edit') {
          oldElements.forEach(e => {
            if(e.product == pid) {
              let inc = 1;
              if(e.weight) {
                inc = e.weight;
              } else if(product.stockType === 3 && product.defaultQuantity) {
                inc = product.defaultQuantity;
              }
              variation -= inc;
            }
          });
        }

        if(variation != 0) {
          product.quantity -= variation;

          const logEntryUom = product.stockType === 3 ? product.uom : null;
          const inventoryLogEntry = {
            product: pid,
            productCode: product.code,
            productName: product.name,
            productUnitPrice: product.price,
            productVat: product.vat,
            productUom: logEntryUom,
            variation: -1 * variation,
            ts: vue.$moment().unix()
          };
          inventoryLogEntry.id = inventoryLogEntry.dbKey = vue.$anm22.genLocalId();

          dbPromises.push(
            vue.$store.dispatch("foodProducts/update", {
              vlf: vue.$vlf("foodProducts"),
              objs: [product]
            }),
            vue.$store.dispatch('offline/saveSyncTuple', {
              _vue: vue,
              _class: "FoodProduct",
              _table: "foodProducts",
              mode: 'edit',
              type: 'obj',
              obj: product
            }),
            vue.$store.dispatch('offline/saveSyncTuple', {
              _vue: vue,
              _class: "FoodInventoryLogEntry",
              _table: "foodInventoryLogEntries",
              mode: 'new',
              type: 'obj',
              obj: inventoryLogEntry
            })
          );
        }
      }
    });

    // Calcolo eventuali sconti per log e setto i totali
    let previousOrderDiscount = 0, orderDiscount = 0;
    if(mode === 'edit') {
      previousOrderDiscount = order.listTotal - order.toPayTotal - order.payedTotal + order.surcharge;
      orderDiscount = listTotal - toPayTotal - order.payedTotal + order.surcharge;
    } else {
      previousOrderDiscount = 0;
      orderDiscount = listTotal - toPayTotal;
    }
    if(previousOrderDiscount !== orderDiscount) {
      const localId = vue.$anm22.genLocalId();
      logs.push({
        id: localId,
        dbKey: localId,
        license: license.id,
        user: user.idWorldUser,
        order: order.id,
        ts: vue.$moment().unix(),
        type: 5,
        details: {
          oldDiscount: previousOrderDiscount,
          discount: orderDiscount,
          listTotal: listTotal
        }
      });
    }
    order.listTotal = listTotal;
    order.toPayTotal = toPayTotal;

    // PUSH DB PROMISE SYNC ORDER NEW OR EDIT
    dbPromises.push(
      vue.$store.dispatch('foodOrders/update', {
        vlf: vue.$vlf('foodOrders'), objs: [order]
      }),
      vue.$store.dispatch('offline/saveSyncTuple', {
        _vue: vue,
        _class: "FoodOrder",
        _table: "foodOrders",
        mode: mode,
        type: 'obj',
        obj: order
      })
    );
    // Order elements
    elementsToSave.new.forEach(e => {
      dbPromises.push(
        vue.$store.dispatch('foodOrderElements/update', {
          vlf: vue.$vlf('foodOrderElements'), objs: [ e ]
        }),
        vue.$store.dispatch('offline/saveSyncTuple', {
          _vue: vue,
          _class: "FoodOrderElement",
          _table: "foodOrderElements",
          mode: 'new',
          type: 'obj',
          obj: e
        })
      );
    });
    elementsToSave.edit.forEach(e => {
      dbPromises.push(
        vue.$store.dispatch('foodOrderElements/update', {
          vlf: vue.$vlf('foodOrderElements'), objs: [ e ]
        }),
        vue.$store.dispatch('offline/saveSyncTuple', {
          _vue: vue,
          _class: "FoodOrderElement",
          _table: "foodOrderElements",
          mode: 'edit',
          type: 'obj',
          obj: e
        })
      );
    });
    elementsToSave.delete.forEach(e => {
      dbPromises.push(
        vue.$store.dispatch('foodOrderElements/delete', {
          vlf: vue.$vlf('foodOrderElements'), obj: e
        }),
        vue.$store.dispatch('offline/saveSyncTuple', {
          _vue: vue,
          _class: "FoodOrderElement",
          _table: "foodOrderElements",
          mode: 'delete',
          type: 'obj',
          obj: e
        })
      );
    });
    // Aggiorno dati aggregati del tavolo
    if(order.tableRef) {
      const table = vue.$store.getters['foodTables/get'](order.tableRef);
      table.isOccupied = order.id;
      dbPromises.push(
        vue.$store.dispatch('foodTables/update', {
          vlf: vue.$vlf('foodTables'), objs: [table]
        })
      );
    }
    await Promise.all(dbPromises);
    // PRINT COMANDA
    let printData = {};
    if(order.status >= 3) {
      Object.entries(toPrint).forEach(t => {
        const pid = t[0], data = t[1];
        printData = {};
        let counter = 1;
        data.new.sort((a,b) => a.id - b.id)
          .forEach(e => {
            if(!printData[e.sequence]) {
              printData[e.sequence] = {};
            }
            if(e.weight) {
              printData[e.sequence]['el-' + counter++] = {
                name: e.weight + ' ' + e.productName,
                qnt: 1,
                variations: e.variations
              }
            } else if(e.variations.length > 0) {
              printData[e.sequence]['el-' + counter++] = {
                name: e.productName,
                qnt: 1,
                variations: e.variations
              }
            } else {
              if(!printData[e.sequence][e.product]) {
                printData[e.sequence][e.product] = {
                  name: e.productName,
                  qnt: 1,
                  variations: []
                }
              } else {
                printData[e.sequence][e.product].qnt++;
              }
            }
          });
        data.delete.sort((a,b) => a.id - b.id)
          .forEach(e => {
            if(!printData[e.sequence]) {
              printData[e.sequence] = {};
            }
            if(e.weight) {
              printData[e.sequence]['el-' + counter++] = {
                name: e.weight + ' ' + e.productName,
                qnt: -1,
                variations: e.variations
              }
            } else if(e.variations.length > 0) {
              printData[e.sequence]['el-' + counter++] = {
                name: e.productName,
                qnt: -1,
                variations: e.variations
              }
            } else {
              if(!printData[e.sequence][e.product]) {
                printData[e.sequence][e.product] = {
                  name: e.productName,
                  qnt: -1,
                  variations: []
                }
              } else {
                printData[e.sequence][e.product].qnt--;
              }
            }
          });
        for (let i = 0; i < printData.length; i++) {
          const seq = printData[i];
          for (let j = 0; j < seq.length; j++) {
            const row = seq[j];
            if(row.qnt == 0){
              printData[i].splice(j, 1);
            }
          }
          if(printData[i].length === 0) {
            printData.splice(i, 1);
          }
        }
        if(Object.keys(printData).length > 0) {
          printData.orderId = order.id;
          if(mode === 'edit') {
            printData.type = vue.$anm22.strLang(lang, 'EDIT', 'MODIFICA');
          } else {
            printData.type = vue.$anm22.strLang(lang, 'NEW', 'NUOVO');
          }
          if(order.notes) {
            printData['notes'] = order.notes.replace('\n', '\\n');
          }
          const orderString = String(order.id);

          const now = vue.$moment.tz(timezone);
          let time, time_format;
          if(order.deliveryType === 5) {
            time = vue.$moment.unix(order.orderDate).tz(timezone);
          } else {
            time = vue.$moment.unix(order.deliveryTime).tz(timezone);
          }
          if(now.isSame(time, 'year month day')) {
            time_format = 'HH:mm';
          } else {
            time_format = 'YYYY-MM-DD HH:mm';
          }
          printData['time'] = time.format(time_format);

          switch(Number(order.deliveryType)) {
            case 1:
            case 2:
              const beach = vue.$store.getters['works/get'](order.beach);
              printData['delivery'] = 
                  vue.$anm22.strLang(lang, 'UMBRELLA', 'OMBRELLONE') + ' ' + order.beachUmbrella;
              break;
            case 3:
              printData['delivery'] = 'CHIRINGUITO';
              break;
            case 4:
              printData['delivery'] = 'BAR';
              break;
            case 5:
              const table = vue.$store.getters['foodTables/get'](order.tableRef);
              printData['delivery'] = vue.$anm22.strLang(lang, 'TABLE', 'TAVOLO') + ' ' + table.name;
              if(order.tableAlias) {
                printData['delivery'] += ' - ' + order.tableAlias;
              }
              break;
            case 7:
              printData['delivery'] = 'DOMICILIO||';
              printData['delivery'] += order.deliveryData.name + '||';
              printData['delivery'] += order.deliveryData.street + ' ' + order.deliveryData.number + '||';
              if(order.deliveryData.line2) {
                printData['delivery'] += order.deliveryData.line2 + '||';
              }
              printData['delivery'] += order.deliveryData.zip + ' ' + order.deliveryData.city + ' ' + order.deliveryData.state + '||';
              printData['delivery'] += vue.$anm22.tableClasses.worldCountry().getById(order.deliveryData.country)[lang];
              printData['delivery'] += order.deliveryData.phone;
              printData['delivery'] += order.deliveryData.notes;
              break;
            case 9:
              printData['delivery'] = "PUNTO DI RITIRO||";
              printData['delivery'] += order.pickUpPoint[lang];
              break;
            case 10:
              printData['delivery'] = 'BUNGALOW||';
              printData['delivery'] += order.deliveryData.name + '||';
              printData['delivery'] += order.deliveryData.street + ' ' + order.deliveryData.number + '||';
              printData['delivery'] += order.deliveryData.phone;
              printData['delivery'] += order.deliveryData.notes;
              break;
          }
          const tuple = {
            idPrinter: pid,
            printData: printData,
            printed: 0,
            license: license.id,
            order: order.number ? order.number : order.id,
            time: vue.$moment().unix()
          };
          tuple.id = tuple.dbKey = vue.$anm22.genLocalId();
          vue.$vlf('fd_print_queue').setItem(tuple.id, tuple);
          vue.$store.dispatch('offline/saveSyncTuple', {
            _vue: vue,
            _class: "FoodPrintQueue",
            _table: "fd_print_queue",
            mode: 'new',
            type: 'obj',
            obj: tuple
          });
        }
      });
      //STAMPA COMANDA VIRTUALE - notifica serve ??
      printData = {
        orderId: order.id,
        type: mode === 'edit' ? 'modified' : 'new',
        customer: null,
        amount: order.toPayTotal + order.payedTotal
      };
      const tuple = {
        idPrinter: 0,
        printData: printData,
        printed: 0,
        license: license.id,
        order: order.number ? order.number : order.id,
        time: vue.$moment().unix()
      };
      tuple.id = tuple.dbKey = vue.$anm22.genLocalId();
      vue.$vlf('fd_print_queue').setItem(tuple.id, tuple);
      vue.$store.dispatch('offline/saveSyncTuple', {
        _vue: vue,
        _class: "FoodPrintQueue",
        _table: "fd_print_queue",
        mode: 'new',
        type: 'obj',
        obj: tuple
      });
    }

    // SAVE FOOD LOG
    logData.order = {...order};
    const foodLog = {
      license: license.id,
      user: user.idWorldUser,
      ts: vue.$moment().unix(),
      order: order.id,
      type: mode === 'edit' ? 2 : 1,
      details: logData
    };
    foodLog.id = foodLog.dbKey = vue.$anm22.genLocalId();
    logs.push(foodLog);

    logs.forEach(log => {
      vue.$store.dispatch('offline/saveSyncTuple', {
        _vue: vue,
        _class: "FoodLog",
        _table: "foodLogs",
        mode: 'new',
        type: 'obj',
        obj: log
      });
    })

    return order.id;
  },
  deleteOrder({ vue, license, order, pin }) {
    let user = vue.$store.state.auth.user;
    if (pin) {
      const employment = vue.$store.getters["foodEmployments/getByPin"](pin);
      if (employment) {
        user = vue.$store.getters["users/get"](employment.administrator);
      } else {
        return Promise.resolve({ error: "No employment found" });
      }
    }
    const elements = vue.$store.getters['foodOrderElements/getByOrder'](order.id);
    const payments = vue.$store.getters['foodPayments/getByOrder'](order.id);
    const foodLog = {
      license: license.id,
      user: user.idWorldUser,
      ts: vue.$moment().unix(),
      order: order.id,
      type: 3,
      details: {
        order: order,
        elements: elements,
        payments: payments
      }
    };
    foodLog.id = foodLog.dbKey = vue.$anm22.genLocalId();
    // free table
    if(order.tableRef) {
      const table = vue.$store.getters['foodTables/get'](order.tableRef);
      table.isOccupied = "";
      vue.$store.dispatch('foodTables/update', {
        vlf: vue.$vlf('foodTables'), objs: [table]
      });
      vue.$store.dispatch('offline/saveSyncTuple', {
        _vue: vue,
        _class: "FoodTable",
        _table: "foodTables",
        mode: 'edit',
        type: 'obj',
        obj: table
      });
    }
    return Promise.all([
      vue.$store.dispatch('foodOrders/delete', {
        vlf: vue.$vlf('foodOrders'), obj: order
      }),
      vue.$store.dispatch('offline/saveSyncTuple', {
        _vue: vue,
        _class: "FoodOrder",
        _table: "foodOrders",
        mode: 'delete',
        type: 'obj',
        obj: order
      }),
      vue.$store.dispatch('foodOrderElements/deleteMultiple', {
        vlf: vue.$vlf('foodOrderElements'), objs: elements
      }),
      elements.map(e => 
        vue.$store.dispatch('offline/saveSyncTuple', {
          _vue: vue,
          _class: "FoodOrderElement",
          _table: "foodOrderElements",
          mode: 'delete',
          type: 'obj',
          obj: e
        })
      ),
      vue.$store.dispatch('foodPayments/deleteMultiple', {
        vlf: vue.$vlf('foodPayments'), objs: payments
      }),
      payments.map(p => 
        vue.$store.dispatch('offline/saveSyncTuple', {
          _vue: vue,
          _class: "foodPayment",
          _table: "foodPayments",
          mode: 'delete',
          type: 'obj',
          obj: p
        })
      ),
      vue.$store.dispatch('offline/saveSyncTuple', {
        _vue: vue,
        _class: "FoodLog",
        _table: "foodLogs",
        mode: 'new',
        type: 'obj',
        obj: foodLog
      })
    ]);
  },
  async pay({ vue, license, pin, order, paymentId, paymentData }) {
    const lang = vue.$store.state.lang,
        user = vue.$store.state.auth.user;

    // Totali progressivi
    let paymentListTotal = 0, paymentVat = 0, orderToPayTotal = 0;

    // Gestione PIN per autenticazione in cassa rapida
    if (pin) {
      const employment = vue.$store.getters["foodEmployments/getByPin"](pin);
      if (employment) {
        user = vue.$store.getters["users/get"](employment.administrator);
      } else {
        return Promise.resolve({ error: "No employment found" });
      }
    }
    
    // Pagamento
    const payment = {};
    payment.id = payment.dbKey = paymentId;
    payment.ts = vue.$moment().unix();
    payment.order = order.id;
    payment.payedTotal = paymentData.payedTotal;
    payment.receipt = paymentData.receiptType === 'noPrint' ? '' : paymentData.receiptType;
    payment.method = order.paymentMethod;
    payment.data = order.paymentData;

    const idsToPay = paymentData.elementIds;
    const elements = vue.$store.getters['foodOrderElements/getByOrder'](order.id);

    let orderPayed = true;
    elements.forEach(element => {
      const vPrice = element.variations.reduce((acc, v) => acc + v.price, 0);
      // Controllo se l'elemento è uno di quelli pagati con questa transazione, nel caso
      // inserisco il riferimento al pagamento
      if(idsToPay.includes(element.id)) {
        element.payment = payment.id;
        paymentListTotal += element.price + vPrice;
        paymentVat += element.price - (element.price / (1 + element.productVat / 100));
        paymentVat += vPrice - (vPrice / (1 + element.productVat / 100));
      } 
      if(!element.payment) {
        orderPayed = false;
        orderToPayTotal += element.price + vPrice;
      }
    });
    
    /* AGGIORNAMENTO DATI ORDINE */
    order.receiptType = payment.receipt;
    if(orderPayed) {
      order.payed = true;
      order.status = 6;
    }
    // Coperti
    if(paymentData.covers) {
      const covers = order.covers;
      cToPay = paymentData.covers;
      for (let i = 0; i < covers[0].length; i++) {
        if(!covers[0][i] && cToPay > 0) {
          covers[0][i] = payment.id;
          paymentListTotal += covers[1];
          paymentVat += covers[1] - (covers[1] / 1.1);
          cToPay--;
        } else {
          orderToPayTotal += covers[1];
        }
      }
      order.covers = covers;
    }
    // Costo di spedizione
    if(!!paymentData.delivery) {
      order.deliveryPayment = payment.id;
      paymentListTotal += order.deliveryPrice;
      paymentVat += order.deliveryPrice - (order.deliveryPrice / 1.1);
    }
    if(!order.deliveryPayment) {
      orderToPayTotal += order.deliveryPrice;
    }
    // Discount
    const paymentDiscount = paymentListTotal - payment.payedTotal;
    if(paymentDiscount !== 0) {
      paymentVat -= paymentDiscount - (paymentDiscount / 1.1);
    }

    payment.vat = paymentVat;
    payment.listTotal = paymentListTotal;
    payment.surcharge = 0;
    payment.invoice = "";

    await Promise.all([
      vue.$store.dispatch('foodPayments/update', {
        vlf: vue.$vlf('foodPayments'), objs: [ payment ]
      }),
      vue.$store.dispatch('offline/saveSyncTuple', {
        _vue: vue,
        _class: "FoodPayment",
        _table: "foodPayments",
        mode: 'new',
        type: 'obj',
        obj: payment
      })
    ]);

    // Totali ordini
    const orderVat = order.totalVAT + paymentVat;
    const orderPayedTotal = order.payedTotal + payment.payedTotal;
    
    order.toPayTotal = orderToPayTotal;
    order.totalVAT = orderVat;
    order.payedTotal = orderPayedTotal;
    order.lastModified = vue.$moment().unix();

    // free table
    if(order.tableRef && orderPayed) {
      const table = vue.$store.getters['foodTables/get'](order.tableRef);
      table.isOccupied = "";
      vue.$store.dispatch('foodTables/update', {
        vlf: vue.$vlf('foodTables'), objs: [table]
      });
      vue.$store.dispatch('offline/saveSyncTuple', {
        _vue: vue,
        _class: "FoodTable",
        _table: "foodTables",
        mode: 'edit',
        type: 'obj',
        obj: table
      });
    }
    // Update order and elements
    vue.$store.dispatch('foodOrders/update', {
      vlf: vue.$vlf('foodOrders'), objs: [ order ]
    }),
    vue.$store.dispatch('offline/saveSyncTuple', {
      _vue: vue,
      _class: "FoodOrder",
      _table: "foodOrders",
      mode: 'edit',
      type: 'obj',
      obj: order
    });
    elements.forEach( element => {
        vue.$store.dispatch('foodOrderElements/update', {
          vlf: vue.$vlf('foodOrderElements'), objs: [ element ]
        }),
        vue.$store.dispatch('offline/saveSyncTuple', {
          _vue: vue,
          _class: "FoodOrderElement",
          _table: "foodOrderElements",
          mode: 'edit',
          type: 'obj',
          obj: element
        })
      }
    );

    const foodLog = {
      license: license.id,
      user: user.idWorldUser,
      ts: vue.$moment().unix(),
      order: order.id,
      type: 4,
      details: {
        ...payment
      }
    };
    foodLog.id = foodLog.dbKey = vue.$anm22.genLocalId();
    vue.$store.dispatch('offline/saveSyncTuple', {
      _vue: vue,
      _class: "FoodLog",
      _table: "foodLogs",
      mode: 'new',
      type: 'obj',
      obj: foodLog
    });
    return payment.id;
  },
  async nextSequence({ vue, order, elements }) {
    const lang = vue.$store.state.lang;
    const license = vue.$store.getters['foodLicenses/get'](order.license);
    const work = vue.$store.getters['works/get'](license.work);
    const timezone = work.timezone;
    let next = order.printedSequence + 1;
    // Controllo elementi sequenza ---- legacy?
    let empty = true;
    while(empty) {
      if(elements.filter(e => e.sequence === next).length > 0) {
        empty = false;
      } else if(elements.filter(e => e.sequence === (next + 1)).length === 0) {
        return false;
      }
    }
    const toPrint = {};
    elements.filter(e => e.sequence === next).forEach(e => {
      const p = vue.$store.getters["foodProducts/get"](e.product);
      const c = vue.$store.getters["foodCategories/get"](p.category);
      if (c.idPrinter) {
        if (p.idPrinter) {
          if (!toPrint[p.idPrinter]) {
            toPrint[p.idPrinter] = [];
          }
          toPrint[p.idPrinter].push(e);
        } else {
          if (!toPrint[c.idPrinter]) {
            toPrint[c.idPrinter] = [];
          }
          toPrint[c.idPrinter].push(e);
        }
      }
    });
    let printData = {};
    Object.entries(toPrint).forEach(t => {
      const pid = t[0], data = t[1];
      printData = {};
      data.sort((a,b) => a.id - b.id)
        .forEach(e => {
          if(!printData[e.sequence]) {
            printData[e.sequence] = {};
          }
          if(e.variations) {
            printData[e.sequence]['el-' + e.id] = {
              name: e.productName,
              qnt: 1,
              variations: e.variations
            }
          } else {
            if(!printData[e.sequence][e.product]) {
              printData[e.sequence][e.product] = {
                name: e.productName,
                qnt: 1,
                variations: []
              }
            } else {
              printData[e.sequence][e.product].qnt++;
            }
          }
        });
        
      printData['orderId'] = order.id;
      if(order.notes) {
        printData['notes'] = order.notes.replace('\n', '\\n');
      }
      
      const now = vue.$moment.tz(timezone);
      let time, time_format;
      if(order.deliveryType === 5) {
        time = vue.$moment.unix(order.orderDate).tz(timezone);
      } else {
        time = vue.$moment.unix(order.deliveryTime).tz(timezone);
      }
      if(now.isSame(time, 'year month day')) {
        time_format = 'HH:mm';
      } else {
        time_format = 'YYYY-MM-DD HH:mm';
      }
      printData['time'] = time.format(time_format);

      switch(Number(order.deliveryType)) {
        case 1:
        case 2:
          const beach = vue.$store.getters['works/get'](order.beach);
          printData['delivery'] = 
              vue.$anm22.strLang(lang, 'UMBRELLA', 'OMBRELLONE') + ' ' + order.beachUmbrella;
          break;
        case 3:
          printData['delivery'] = 'CHIRINGUITO';
          break;
        case 4:
          printData['delivery'] = 'BAR';
          break;
        case 5:
          const table = vue.$store.getters['foodTables/get'](order.tableRef);
          printData['delivery'] = vue.$anm22.strLang(lang, 'TABLE', 'TAVOLO') + ' ' + table.name;
          if(order.tableAlias) {
            printData['delivery'] += ' - ' + order.tableAlias;
          }
          break;
        case 7:
          printData['delivery'] = 'DOMICILIO||';
          printData['delivery'] += order.deliveryData.name + '||';
          printData['delivery'] += order.deliveryData.street + ' ' + order.deliveryData.number + '||';
          if(order.deliveryData.line2) {
            printData['delivery'] += order.deliveryData.line2 + '||';
          }
          printData['delivery'] += order.deliveryData.zip + ' ' + order.deliveryData.city + ' ' + order.deliveryData.state + '||';
          printData['delivery'] += vue.$anm22.tableClasses.worldCountry().getById(order.deliveryData.country)[lang];
          printData['delivery'] += order.deliveryData.phone;
          printData['delivery'] += order.deliveryData.notes;
          break;
        case 9:
          printData['delivery'] = "PUNTO DI RITIRO||";
          printData['delivery'] += order.pickUpPoint[lang];
          break;
        case 10:
          printData['delivery'] = 'BUNGALOW||';
          printData['delivery'] += order.deliveryData.name + '||';
          printData['delivery'] += order.deliveryData.street + ' ' + order.deliveryData.number + '||';
          printData['delivery'] += order.deliveryData.phone;
          printData['delivery'] += order.deliveryData.notes;
          break;
      }
      const tuple = {
        dbKey: print_id,
        idPrinter: pid,
        printData: printData,
        printed: 0,
        license: license.id,
        order: order.number ? order.number : order.id,
        time: vue.$moment().unix()
      };
      tuple.id = tuple.dbKey = vue.$anm22.genLocalId();
      vue.$vlf('fd_print_queue').setItem(tuple.id, tuple);
      // vue.$anm22.saveSyncTuple(vue, "FoodPrintQueue", "new", tuple);
      vue.$store.dispatch('offline/saveSyncTuple', {
        _vue: vue,
        _class: "FoodPrintQueue",
        _table: "fd_print_queue",
        mode: 'new',
        type: 'obj',
        obj: tuple
      });
    });
    order.printedSequence = next;
    order.printedSequenceTime = vue.$moment().unix();
    await Promise.all([
      vue.$store.dispatch('foodOrders/update', {
        vlf: vue.$vlf('foodOrders'), objs: [order]
      }),
      vue.$store.dispatch('offline/saveSyncTuple', {
        _vue: vue,
        _class: "FoodOrder",
        _table: "foodOrders",
        mode: "edit",
        type: 'obj',
        obj: order
      })
    ]);
  },
  /**
   *  
   * @param {object} data - Options object
   * @param {object} data.vue - Vue instance 
   * @param {number} data.printer - Printer ID
   * @param {string} data.printMode - Printer Mode
   * @param {object} data.rows - Rows to print
   * @param {array} data.covers - Covers to print, [number, price]
   * @param {number} data.delivery - Delivery cost
   * @param {number} data.discount - Discount
   * @param {number} data.surcharge - Surcharge
   * @param {number} paymentMethod - Payment method
   * @param {string} notes - Notes to print
   * @param {string} lotteryCode - Receipt Lottery Code
   * @param {function} callbackMethod - Callback function to call after printing
   */
  anm22_print: function(data) {
    const vue = data.vue || null;
    const printer = data.printer || null;
    const printMode = data.printMode || null;
    const rows = data.rows || [];
    const covers = data.covers || [];
    const delivery = data.delivery || 0;
    const discount = data.discount || 0;
    const surcharge = data.surcharge || 0;
    const paymentMethod = data.paymentMethod || 0;
    const notes = data.notes || "";
    const lotteryCode = data.lotteryCode || "";
    const callbackMethod = data.callbackMethod || null;
    if(!vue) {
      console.log("[PRINT] No Vue instance provided");
      return;
    }
    if(!printer) {
      console.log("[PRINT] No printer ID provided");
      return;
    }
    if(!printMode) {
      console.log("[PRINT] No print mode selected");
      return;
    }
    if(rows.length === 0) {
      console.log("[PRINT] No rows to print");
      return;
    }
    let total = 0;
    // Creo gli articoli di stampa
    let articles = [];
    rows.forEach(function(row) {
      let price = 0;
      const variations = [];
      const article = new WorldPrintArticle();
      if(row.elem.weight) {
        article.description = row.elem.weight + ' ' 
            + vue.$anm22.tableClasses.foodUnitOfMeasurement().getById(row.elem.productUom)['typeClassLiteral']
            + ' ' + row.elem.productName;
      } else {
        article.description = row.elem.productName;
      }
      article.quantity = row.quantity;
      article.vat = row.elem.productVat;
      // Potrei avere articoli con prezzi modificati in modo unitario, quindi divido il totale della riga per la quantità
      // in modo che torni il prezzo della singola unità
      total += row.price;
      price += vue.$anm22.round(row.price / row.quantity, 2);
      if (row.elem.variations.length > 0) {
        row.elem.variations.forEach(function(_var) {
          //Stampo solo se il prezzo è negativo o positivo
          if (_var.price !== 0) {
            const variation = new WorldPrintArticle();
            variation.description = "   " + _var.sign + ' ' + vue.$anm22.food_getVariationName(vue.lang, _var);
            variation.quantity = 1;
            variation.vat = row.elem.productVat;
            if (_var.price < 0) {
              variation.price = 0;
              price += _var.price;
            } else {
              variation.price = _var.price;
            }
            total += variation.price;
            variations.push(variation);
          }
        });
      }
      article.price = price;
      articles.push(article);
      articles = articles.concat(variations);
    });
    if (covers !== [] && covers[0]) {
      const article = new WorldPrintArticle();
      article.description = vue.$anm22.strLang(vue.lang, "Cover", "Coperto");
      article.quantity = covers[0];
      article.price = covers[1];
      article.vat = vue.license.coverVat;
      articles.push(article);
      total += covers[0] * covers[1];
    }
    if (delivery !== 0) {
      const article = new WorldPrintArticle();
      article.description = vue.$anm22.strLang(
        vue.lang,
        "Delivery cost",
        "Costo di consegna"
      );
      article.quantity = 1;
      article.price = delivery;
      article.vat = vue.license.deliveryVat;
      articles.push(article);
      total += delivery;
    }
    if(surcharge !== 0) {
      const article = new WorldPrintArticle();
      article.description = vue.$anm22.strLang(
        vue.lang,
        "Service cost",
        "Costo di servizio"
      );
      article.quantity = 1;
      article.price = surcharge;
      article.vat = vue.license.deliveryVat;
      articles.push(article);
      total += surcharge;
    }
    // Converto metodo di pagamento in valori predefiniti
    let pm = '';
    switch(paymentMethod) {
      case 2: 
        pm = WorldPrintContent_PaymentMethods.BANCOMAT;
        break;
      case 3: 
      case 4:
      case 10:
        pm = WorldPrintContent_PaymentMethods.CARTA;
        break;
      case 7:
        pm = WorldPrintContent_PaymentMethods.NON_RISCOSSO;
        break;
      case 1:
      case 5:
      case 9: // Per il pagamento con Tessera World, il metodo di pagamento non è importante in quanto il totale sarà 0
      default:
        pm = WorldPrintContent_PaymentMethods.CONTANTI;
        break;
    }
    // Creo l'oggetto di stampa da passare alla stampante
    var world_print_content = new WorldPrintContent();
    world_print_content.printMode = printMode;
    world_print_content.articles = articles;
    world_print_content.discount = discount;
    world_print_content.paymentMethod = pm;
    world_print_content.notes = notes;
    world_print_content.lotteryCode = lotteryCode || "";
    world_print_content.timestamp = Math.floor(Date.now() / 1000);
    // Buono monouso tessera Pay
    if(paymentMethod == 9) {
      if(discount) {
        total += -1 * discount;
      }
      world_print_content.singleUseVouchers = [{
        vat: 10,
        amount: total
      }];
    }
    // Chiamo il metodo print sulla stampante
    window["world_printer_" + printer].print(
      world_print_content,
      callbackMethod
    );
  },
  haversineGreatCircleDistance(from, to) {
    const earthRadius = 6371;

    const latFrom = from.lat * Math.PI / 180;
    const lngFrom = from.lng * Math.PI / 180;
    const latTo = to.lat * Math.PI / 180;
    const lngTo = to.lng* Math.PI / 180;

    const latDelta = latTo - latFrom;
    const lngDelta = lngTo - lngFrom;

    const angle = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(latDelta / 2), 2) +
        Math.cos(latFrom) * Math.cos(latTo) * Math.pow(Math.sin(lngDelta / 2), 2)));
    return angle * earthRadius;

  }
};
